import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Fashion from '../components/Fashion'
import Detail from '../components/Detail'
import Usedcard from '../components/Usedcard'
import Usedidle from '../components/Usedidle'
import Houserental from '../components/Houserental'
import Lifeservices from '../components/Lifeservices'
import Feerules from '../components/Feerules'
import Login from '../components/Login'
import Register from '../components/Register'
import Forgotpassword from '../components/Forgotpassword'
import Releaseinfo from '../components/Releaseinfo'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },

    {
      path: '/fashion',
      name: 'Fashion',
      component: Fashion
    },
    {
      path: '/detail',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/usedcard',
      name: 'Usedcard',
      component: Usedcard
    },
    {
      path: '/usedidle',
      name: 'Usedidle',
      component: Usedidle
    },
    {
      path: '/houserental',
      name: 'Houserental',
      component: Houserental
    },
    {
      path: '/lifeservices',
      name: 'Lifeservices',
      component: Lifeservices
    },
    {
      path: '/feerules',
      name: 'Feerules',
      component: Feerules
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/forgotpassword',
      name: 'Forgotpassword',
      component: Forgotpassword
    },
    {
      path: '/releaseinfo',
      name: 'Releaseinfo',
      component: Releaseinfo
    },
  ]
})

